import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { SenaryParagraphHeading } from 'components/Headings';
import { TYPES } from 'constants/topNavigation';
import Theme from 'styles/theme';

const TopNavigationHeaderDesktopLink = ({
  url,
  label,
  trackNavigationRerunRenamingExperimentEngagement,
  navigationRerunRenamingExperimentAnalyticsData,
  trackNavigation,
  trackNavigationClick,
  isSalesColorRed,
}) => {
  const handleTracking = () => {
    trackNavigation(url);
    trackNavigationClick({
      navigationType: TYPES.GLOBAL,
      navigationLevel1: label,
      navigationSource: window.location.href,
    });

    if (
      navigationRerunRenamingExperimentAnalyticsData &&
      Object.keys(navigationRerunRenamingExperimentAnalyticsData).length > 0
    ) {
      trackNavigationRerunRenamingExperimentEngagement(
        navigationRerunRenamingExperimentAnalyticsData.dyDecisionId,
        navigationRerunRenamingExperimentAnalyticsData.dyVariationId
      );
    }
  };

  return (
    <div className="TopNavigationHeaderDesktop__link-wrapper">
      <a
        href={url}
        onClick={() => handleTracking()}
        className={classNames('TopNavigationHeaderDesktop__link', {
          'TopNavigationHeaderDesktop__link--red-color': isSalesColorRed,
        })}
      >
        <SenaryParagraphHeading className="TopNavigationHeaderDesktop__link-label">
          {label}
        </SenaryParagraphHeading>
      </a>
      <style jsx>{`
        .TopNavigationHeaderDesktop__link {
          text-decoration: none;
          align-items: center;
          cursor: pointer;
          position: relative;
        }

        .TopNavigationHeaderDesktop__link-wrapper {
          margin: 0 0 auto ${Theme.get('spacing') * 5}px;
        }

        .TopNavigationHeaderDesktop__link-wrapper:hover * {
          text-decoration: underline;
        }
      `}</style>

      <style jsx global>{`
        .TopNavigationHeaderDesktop__link--red-color .TopNavigationHeaderDesktop__link-label {
          color: ${Theme.get('colors-discount-red')};
        }
        a.TopNavigationHeaderDesktop__link {
          line-height: ${Theme.get('line-height')};
          display: inline-block;
          min-height: 42px;
          min-width: 42px;
          display: flex;
          justify-content: center;
        }
      `}</style>
    </div>
  );
};

TopNavigationHeaderDesktopLink.propTypes = {
  url: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  trackNavigation: PropTypes.func.isRequired,
  trackNavigationClick: PropTypes.func.isRequired,
  trackNavigationRerunRenamingExperimentEngagement: PropTypes.func,
  isSalesColorRed: PropTypes.bool,
  navigationRerunRenamingExperimentAnalyticsData: PropTypes.shape({
    dyDecisionId: PropTypes.string,
    dyVariationId: PropTypes.number,
  }),
};

TopNavigationHeaderDesktopLink.defaultProps = {
  isSalesColorRed: false,
  trackNavigationRerunRenamingExperimentEngagement: () => {},
  navigationRerunRenamingExperimentAnalyticsData: null,
};

export default TopNavigationHeaderDesktopLink;
